import { render, staticRenderFns } from "./btnauth.vue?vue&type=template&id=0667e7ec"
import script from "./btnauth.vue?vue&type=script&lang=js"
export * from "./btnauth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports